import React from 'react'
import './index.scss'

const Card = ({className = '', children}) => (
  <div className={['card', className].join(' ').trim()}>
    {children}
  </div>
)

Card.Content = ({children}) => (
  <div className="content">
    {children}
  </div>
)

Card.Actions = ({children}) => (
  <div className="actions">
    {children}
  </div>
)

export default Card
